<template>
    <div v-if="userInfo && canSysAdmin(userInfo)">
         <div class="text-right">
            <b-button  variant="primary" size="sm" v-b-modal.addModal>New Location</b-button>
         </div>
         <b-overlay :show="isBusy" rounded="sm" >
            <b-table-simple bordered hover small responsive>
                <b-thead head-variant="none">                            
                    <b-tr>
                        <b-th>Name</b-th>
                        <b-th>Phone</b-th>
                        <b-th>Friendly Id</b-th>                        
                        <b-th>Address</b-th>   
                        <b-th>City</b-th>                                                
                        <b-th>Organization</b-th>
                        <b-th>Action</b-th>                        
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(location) in locations" :key="location._id">                               
                        <b-td>{{location.name}}</b-td>                          
                        <b-td>{{location.phone}}</b-td>
                        <b-td>{{location.friendlyId}}</b-td>
                        <b-td>{{location.address}}</b-td>
                        <b-td>{{location.city}}</b-td>                        
                        <b-td>{{location.organization?location.organization.name:''}}</b-td>                        
                        <b-td>
                            <b-button variant="link" size="sm" borderless @click="onViewLocation(location)" 
                                      v-b-tooltip.hover.bottom title="View">
                                <b-icon icon="eye-fill" variant="primary"></b-icon>
                            </b-button>
                            <b-button variant="link" size="sm" borderless @click="onEditLocation(location)"
                                      v-b-tooltip.hover.bottom title="Edit">
                                <b-icon icon="pencil-square" variant="info"></b-icon>
                            </b-button>
                            <b-button v-if="isUserRoot(userInfo)" variant="link" size="sm" borderless @click="onDeleteLocation(location)"
                                      v-b-tooltip.hover.bottom title="Delete">
                                <b-icon icon="trash-fill" variant="danger"></b-icon>
                            </b-button>
                        </b-td>
                    </b-tr>   
                </b-tbody>
            </b-table-simple>            
         </b-overlay>

         <b-modal id="addModal" ref="addModal" title="New Location" size="xl" hide-footer>
             <location
                v-model="newLocation"
                :wantEdit="true"
                confirmTitle="Add"
                :isBusy="isBusyUpdating"
                @onSubmitLocation="onSubmitNewLocation" />
         </b-modal>

         <b-modal id="editModal" ref="editModal" :title="(wantEdit?'Edit':'View') + ' Location'" size="xl"
             hide-footer no-close-on-backdrop no-close-on-esc>
            <location
                v-model="editLocation"
                :wantEdit="wantEdit"
                :confirmTitle="wantEdit?'Save':''"
                :isBusy="isBusyUpdating"
                @onSubmitLocation="onSubmitEditLocation" />
         </b-modal>
    </div>
    <b-container v-else>
        You dont have access locations    
    </b-container>   
</template>

<script>
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import _timezones from "@/assets/json/timezones.json"//http://worldtimeapi.org/
import Location from '@/components/portal/Location.vue'
import Vue from 'vue'

export default {
    props : [ "appbus" ],
    components : { Location },
    data() {
       return {
           isBusy:false,
           isBusyUpdating:false,
           organizations:[],
           locations: [],
           newLocation: { },
           editLocation: {},
           wantEdit:false,
           timeZones:_timezones,
           paymentSystems:[{ text:"Square", value:"square" }, { text:"Stripe", value:"stripe" }]
        }
    },
    computed: { 
        ...mapState({
            store: 'store',
            selectedOrganization : 'selectedOrganization'            
        }),
        userInfo(){
            return this.$store.getters.getUserInfo;
        },        
    },
    watch:{
         selectedOrganization: {
            deep: true,
            immediate: true,
            handler(){
                this.request = { next : true , limit: undefined}
                this.fetchLocationsList();      
            }
        }
    },
    methods:{
        fetchLocationsList(){
            this.isBusy = true;
            this.$store.dispatch('apiLocation' , { all : 1 })
                       .then(({status, res, error}) => {
                           this.isBusy = false;
                           if(status){
                               this.locations = res
                           }else{
                               console.error("apiLocationsList-E", error)   
                           }
                       })
                       .catch(error=>{
                           this.isBusy = false;
                           console.error("apiLocationsList-E", error)   
                       })
        },
        onSubmitNewLocation(_location) {
            this.isBusyUpdating = true;
            this.$store.dispatch('apiNewLocation', _location)
                    .then(({status, res, error}) => {
                        this.isBusyUpdating = false;
                        if(status){
                            this.locations.push(res);
                            this.newLocation = { }
                            this.$bvModal.hide("addModal")
                            this.updateHeaderLocations();
                        }else{
                            console.error("error",error)
                            Swal.fire('Error',error.msg,'error')
                        }
                    })
                    .catch(({error, msgError})=>{
                        this.isBusyUpdating = false;
                        console.error("apiNewLocation-E", error)  
                        Swal.fire('Error',msgError,'error')   
                    })            
        },
        onViewLocation(location){
            this.editLocation = this.$deepCopy(location);
            this.$bvModal.show("editModal")
            this.wantEdit = false;
        },
        onEditLocation(location){
            this.editLocation = this.$deepCopy(location);
            this.$bvModal.show("editModal")
            this.wantEdit = true;
        },
        onSubmitEditLocation(_location){
            this.isBusyUpdating = true;
            this.$store.dispatch('apiEditLocation', _location)
                    .then(({status, error}) => {
                        this.isBusyUpdating = false;
                        if(status) {
                            let index = this.locations.findIndex(({_id})=> _id === _location._id);
                            Vue.set(this.locations, index, _location)
                            // this.locations.splice(index, 1, _location)
                            _location = {}
                            this.$bvModal.hide("editModal")                            
                            this.updateHeaderLocations();
                        } else {
                            console.error("error",error)
                            Swal.fire('Error',error.msg,'error')
                        }
                    })
                    .catch(({error, msgError})=>{
                        this.isBusyUpdating = false;
                        console.error("apiEditLocation-E", error)  
                        Swal.fire('Error',msgError,'error')   
                    })        
        },
        onDeleteLocation(location){
            Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.onSubmitDeleteLocation(location)
                    }
                })
        },        
        onSubmitDeleteLocation(location) {
            this.isBusy = true;
            this.$store.dispatch('apiDeleteLocation', location)
                    .then(({status, error}) => {
                        this.isBusy = false;
                        if(status){                            
                            let index = this.locations.findIndex(({_id})=> _id === location._id);
                            if (index > -1) {
                                this.locations.splice(index, 1);
                                Swal.fire('Deleted!', 'Location has been deleted.','success')
                                this.updateHeaderLocations();
                            }
                        }else{
                            console.error("error",error)
                            Swal.fire('Error',error.msg,'error')
                        }
                    })
                    .catch(({error, msgError})=>{
                        this.isBusy = false;
                        console.error("apiDeleteLocation-E", error)  
                        Swal.fire('Error',msgError,'error')   
                    })          
        },
        updateHeaderLocations(){
            this.appbus.$emit("updateHeaderLocations")
        }
    },
    mounted(){
        // this.fetchLocationsList()
    }
}
</script>